import { render, staticRenderFns } from "./user_gl.vue?vue&type=template&id=20281dbe&scoped=true"
import script from "./user_gl.vue?vue&type=script&lang=js"
export * from "./user_gl.vue?vue&type=script&lang=js"
import style0 from "./user_gl.vue?vue&type=style&index=0&id=20281dbe&prod&scoped=true&lang=less"
import style1 from "./user_gl.vue?vue&type=style&index=1&id=20281dbe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20281dbe",
  null
  
)

export default component.exports